/**
 * @file コンポーネント：フル動画ページ編集モーダル症例タグリスト ロジック管理
 */

// ライブラリ読み込み
import React, { useEffect, useState } from "react";

// Presenter読み込み
import { Presenter } from "./presenter";

// コンポーネントを返す
export const ModalEditTaglist = (props) => {
    /**
     * フォーム生成
     */
    // 一時保存リストを出力
    const [listTempSelected, setListTempSelected] = useState([]); // 一時保存リスト
    useEffect(() => {
        setListTempSelected(props.list);
    }, []);
    // listSelectが更新される度にidを抽出したリストを更新
    const [listSelectedId, setListSelectedId] = useState([]); // 選択済みIDリスト
    useEffect(() => {
        const result = listTempSelected.map((item) => {
            return item.id;
        });
        setListSelectedId(result);
    }, [listTempSelected]);
    // idだけ抽出したリストが更新される度に検索で出力される候補リストを更新
    const [listSearch, setListSearch] = useState([]); // 候補リスト
    useEffect(() => {
        const result = [];
        document
            .getElementById("search-tags")
            .querySelectorAll("option")
            .forEach((option) => {
                const text = option.textContent.trim();
                const value = Number(option.dataset.tagid);
                if (text !== "" && listSelectedId.indexOf(value) === -1) {
                    result.push({
                        text,
                        value,
                    });
                }
            });
        setListSearch(result);
    }, [listSelectedId]);

    /**
     * クリック時の処理
     */
    // 検索で選択したものを一時保存リストに追加する処理
    const fnOnClickAdd = (e) => {
        e.preventDefault();
        const target = document.getElementsByName(
            "modaleditsearchselect"
        )[0] as HTMLSelectElement;
        const index = target.selectedIndex === -1 ? 0 : target.selectedIndex;
        const value = Number(target.options[index].value);
        const item = listSearch.find(
            (data: { value: number }) => data.value === value
        );
        setListTempSelected([
            ...listTempSelected,
            { id: item.value, name: item.text },
        ]);
    };
    // 一時保存リストから削除する処理
    const fnOnClickDelete = (e) => {
        e.preventDefault();
        const id = Number(e.currentTarget.dataset.id);
        setListTempSelected(listTempSelected.filter((item) => item.id !== id));
    };
    // 症例タグを保存する処理
    const fnOnClickSave = (e) => {
        e.preventDefault();
        const api = "/api/OperationTags/update";
        const options = {
            body: JSON.stringify({
                operationId: window.atob(props.operationId),
                searchTags: listSelectedId,
            }),
            headers: {
                "Content-Type": "application/json",
                RequestVerificationToken: document
                    .getElementById("requestverificationtoken")
                    .getAttribute("value"),
            },
            method: "POST",
        };
        fetch(api, options).then((response) => {
            if (response.status === 200) {
                props.setTaglist(listTempSelected);
                props.setIsOpenModalEdit(false);
            }
        });
    };

    // Presenterに渡す
    return (
        <Presenter
            {...props}
            fnOnClickAdd={fnOnClickAdd}
            fnOnClickDelete={fnOnClickDelete}
            fnOnClickSave={fnOnClickSave}
            listSearch={listSearch}
            listTempSelected={listTempSelected}
        />
    );
};
